<!-- <app-edite-user-details></app-edite-user-details> -->
<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'workers'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'workers'"></app-sidebar>
    <!-- end sidebar  -->

    <!-- start content page  -->
    <main class="p-4 col-lg-10 ">
        <div class="d-md-flex justify-content-between dashboard align-items-center" style="margin-top: 6px; margin-bottom: 24px;">
            <p class="fw-bold ms-1" style="color: #6c6a6a;">workers</p>

            <div class="d-flex justify-content-lg-between ">

                <div class="d-flex justify-content-between ">
                    <!-- <button class="month rounded-start px-3 py-1 outline-none">This Month</button>
                  <button class="week rounded-end px-3 py-1 outline-none">Last Week</button> -->
                </div>

                <!-- start dropdown button  -->
                <app-dropdown class="ms-3" style=" margin-right: 14px;margin-top: 2px;" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown>
                <!-- end dropdown button  -->
                <!-- start addUserButton  -->
                <!-- <app-add-new-button class="ms-3 mt-2" [id]="'app-user-details'"></app-add-new-button> -->
                <!-- end addUserButton  -->
                <a *ngIf="workersRole?.p_Add==true || is_Super==true" class="px-3 py-2 rounded border text-white text-decoration-none" routerLink="/workers/add-workers" style="background-color:#1F4068; cursor: pointer;    width: 53%;">
                    <img src="assets/images/plus.svg" class="me-2 ">Add New
                </a>
            </div>
        </div>
 
        <p-toast></p-toast>
<!--------------------------------------------------------------------------------------->

        <!-- <div class="card">
          <div class="row d-flex justify-content-between align-items-center px-3">
            
           <div class="col-md-4">
            <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">Workers</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{numberworkers}} Workers
              </p>
          </div>
           </div>
          
          <div class="col-md-5 col-8">
              <div class="input">
                <input type="text" class="form-control py-2 w-100" (keyup)="searchAction($event)" [(ngModel)]="searchText" placeholder="Search Worker"/>
                  <img src="../../../assets/images/search.svg" alt="">
              </div>
          </div>
        </div>

            <p-table class="table-shopping" [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}" [value]="workers">
                <ng-template pTemplate="header" class="text-center">
                    <tr *ngIf="headerData">
                        <ng-container>


                            <th class="td-name">
                                Name

                            </th>
                            <th class="td-name">
                                Email

                            </th>
                            <th class="td-name">
                                Phone number

                            </th>
                            <th class="td-name">
                                WhatsApp

                            </th>
                            <th class="td-name">
                                job

                            </th>
                            <th class="td-name">
                                user type

                            </th>
                            <th class="td-name">


                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workers>

                    <tr (click)="hidecard()" style="cursor: pointer;" >


                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            <img *ngIf="workers.worker_Img" [src]="workers?.worker_Img" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px; cursor: pointer;">
                            <img *ngIf="!workers.worker_Img" src="../../../assets/images/Frame 1261154899.svg" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;"> {{workers?.worker_FName}}
                            {{workers?.worker_LName}}

                        </td>
                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            {{workers?.worker_Email}}
                        </td>
                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            {{workers?.worker_PhoneNum}}
                        </td>

                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            {{workers?.worker_WANum}}
                        </td>
                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            {{workers?.worker_Job}}
                        </td>
                        <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
                            {{workers?.worker_Type}}
                        </td>


                        <td class="cursor position-relative" style="text-align: center;">
                            <button class="border-0 outlin-0 bg-transparent" (click)="detailperson($event,workers.worker_ID)">
            <img src="assets/images/edit.svg">
        </button>
                            <div *ngIf="showEdit[workers.worker_ID] " class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
                                <button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100" *ngIf="workersRole?.p_Update==true || is_Super==true" routerLink="/workers/edit-workers/{{workers?.worker_ID}}">update</button>

                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" routerLink="/workers/worker-profile/{{workers?.worker_ID}}"> View Profile  </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" *ngIf="workersRole?.p_Delete==true || is_Super==true" (click)="deleteModal(workers?.worker_ID)">Delete </button>

                            </div>

                        </td>

                    </tr>

                </ng-template>


                <ng-template pTemplate="emptymessage">
                    <div class="container text-center mt-4">
                        <p class="mb-0">No data found.</p>
                    </div>
                </ng-template>

            </p-table>
            <p-paginator *ngIf="workers.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
              [totalRecords]="totalRecords" [first]="first"></p-paginator>
        </div> -->
<!--------------------------------------------------------------------------------------->


      <!-----------------------------------------------------------update----------------------------------------------------------------------------->
      <div>
        <div class="p-card p-3" style="border-radius: 16px;" >
          <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
            <!-- <h2>Subscription Alerts</h2> -->
             <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
             <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">workers</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{totalRecords}} workers
              </p>
          </div>
            <div class="p-inputgroup w-50" style=" position: relative;">
              <!-- <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span> -->
              <input type="text"  class="search-input" pInputText placeholder="      Search any Keywords" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
              <i class="pi pi-search search-icon"></i>
              <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
               <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
            </div>
          </div>
        <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
        <p-table
        #dt2
        [value]="workers"
        dataKey="worker_ID"


        *ngIf="tableReady"
        [paginator]="true" 
        [rows]="10"

       
        [first]="workers.length > 0 ? currentPage : 0"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
       
        
        
        
        [globalFilterFields]="['worker_Email',  'fullName', 'worker_PhoneNum','worker_WANum','worker_Job','worker_Type'  ]"
        [tableStyle]="{ 'min-width': '75rem' }"

        [customSort]="true"
        (sortFunction)="customSort($event)"
    >
        <ng-template pTemplate="caption">
            <!-- <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input 
                        pInputText 
                        type="text" 
                        (input)="dt2.filterGlobal(globalFilter, 'contains')"
                        placeholder="Search keyword" />
                </p-iconField>
            </div> -->
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="headOne">
                <!-- <th style="width:22%">booking ID</th> -->
                <th style="width:22%">Name</th>
                <th style="width:22%"> Email</th>
                <th style="width:22%"> Phone number</th>
                <th style="width:22%">
                  WhatsApp
              </th>
                <th style="width:22%">job</th> 
                <th style="width:22%">user type</th> 
                
                <th style="width:6%">Action</th>

            </tr>
            <tr>
                
                <th>
                    <p-columnFilter 
                        type="text" 
                        field="fullName" 
                        placeholder="Search by Name" 
                        ariaLabel="Filter Name" />
                </th>
                
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="worker_Email" 
                  placeholder="Search by Email" 
                  ariaLabel="Filter Email" />
                </th>

                
                

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="worker_PhoneNum" 
                  placeholder="Search by PhoneNum" 
                  ariaLabel="Filter PhoneNum" />
                </th>

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="worker_WANum" 
                  placeholder="Search by WhatsApp" 
                  ariaLabel="Filter WhatsApp" />
                </th>
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="worker_Job" 
                  placeholder="Search by Job" 
                  ariaLabel="Filter Job" />
                </th> 
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="worker_Type" 
                  placeholder="Search by worker_Type" 
                  ariaLabel="Filter worker_Type" />
                </th>
               
                 
                
                  <!-- <th>
                    <p-columnFilter field="status" matchMode="equals" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th> -->

                 
                  
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-workers>
          <tr style="cursor: pointer;"  >

            <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              <img *ngIf="workers.worker_Img" [src]="workers?.worker_Img" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px; cursor: pointer;">
              <img *ngIf="!workers.worker_Img" src="../../../assets/images/Frame 1261154899.svg" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;"> {{workers?.fullName}}

          </td>
          <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              {{workers?.worker_Email}}
          </td>
          <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              {{workers?.worker_PhoneNum}}
          </td>

          <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              {{workers?.worker_WANum}}
          </td>
          <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              {{workers?.worker_Job}}
          </td>
          <td routerLink="/workers/worker-profile/{{workers?.worker_ID}}">
              {{workers?.worker_Type}}
          </td>

                <td  >
                


                    <!----------------------------->
                    <div   class="flex justify-content-start align-items-center gab-3" style="display: flex;">
                        <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                        <div class=" ">
                          <img
                          routerLink="/workers/worker-profile/{{workers?.worker_ID}}"
                            class="image-default"
                            src="assets/images/viewPay.svg"
                            alt="Default Alert Icon"
                            
                          />
                           
                        </div>
                  
                        
                        <div  >
                          <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                        </div>
                        <p-overlayPanel #op>
                          <ul   class="menu-list list-unstyled">
                            <li style="cursor: pointer; Color:#363636; text-decoration: none;" routerLink="/workers/worker-profile/{{workers?.worker_ID}}">View Profile</li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  
                              *ngIf="workersRole?.p_Update==true || is_Super==true" routerLink="/workers/edit-workers/{{workers?.worker_ID}}">update   </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              *ngIf="workersRole?.p_Delete==true || is_Super==true" (click)="deleteModal(workers?.worker_ID)">Delete</a></li>
                          
                          </ul>
                        
                         
                        </p-overlayPanel>
                      </div>
                
                </td>
 

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No Data Found.</td>
            </tr>
        </ng-template>
</p-table>
<!-- 
	<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator> -->

        </div>
        
      </div>
      <!---------------------------------------------------------------------------------------------------------------------------------------->

    </main>
    <!-- end content page  -->
</div>


<div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}" >
  <div class="modal-dialog modal-dialog-centered" role="document" style="width: 400px;">
        <div class="modal-content">
              <div class="modal-header pb-0 mb-0 d-flex justify-content-end">
                <button type="button" class="close border-0" aria-label="Close" #closebutton (click)="onCloseHandled()">
                  <img src="../../../assets/images/close2.svg" alt="">
                </button>
                  </div>
           <div class="modal-body text-center my-0 py-0">
                  <span><img src="../../../assets/images/delete2.svg" alt=""></span>
                  <h5>Confirm Deletion</h5>
                  <p class="text-muted ">Are you want to delete the worker? </p>
            </div>
                  <div class="modal-footer text-center mx-auto mt-0 pt-0 mb-2">
                    <button type="button" class="btn btn-delete mx-2" data-bs-dismiss="modal" (click)="onCloseHandled()">Cancel</button>
                    <button type="button" class="btn btn-color mx-2" id="closeModal" (click)="deleteworker()" >Delete</button>
                  </div>
     </div>
      </div>
</div>
